@if (isLoadingCities || isLoadingCountries || isLoadingMarkets || isSubmitting || isLoadingNaReviews) {
  <div class="overlay">
    <div class="spinner"></div>
  </div>
}

<div class="breadcrumb-bar">
  <div class="breadcrumb">
    <!-- Generated by GitHub Copilot - Oct-08-2026 -->
    <a class="breadcrumb-link" routerLink="/request" (click)="close.emit()">Request</a>
    <span class="breadcrumb-sep"></span>
    <span class="breadcrumb-current">Create Request</span>
  </div>
</div>

<main class="create-page-content">
  <div class="create-card">
    <h2 class="create-card-title">Create Request</h2>

    <div class="create-form-body">

      <!-- Type of Request -->
      <div class="form-row">
        <label class="field-label">Type of Request <span class="required">*</span></label>

        <!-- Read-only once a type is selected -->
        <div *ngIf="selectedRequestType" class="type-select-readonly">
          <span>{{ selectedRequestType }}</span>
          <mat-icon class="select-arrow">keyboard_arrow_down</mat-icon>
        </div>

        <!-- Dropdown when no type selected yet -->
        <div *ngIf="!selectedRequestType" class="type-select-trigger" (click)="toggleTypeDropdown()">
          <span class="select-placeholder">Select Request Type...</span>
          <mat-icon class="select-arrow">keyboard_arrow_down</mat-icon>
          <div class="type-dropdown-list" *ngIf="showTypeDropdown" (click)="$event.stopPropagation()">
            <div class="type-option" *ngFor="let opt of requestTypeOptions" (click)="selectRequestType(opt)">
              {{ opt }}
            </div>
          </div>
        </div>
      </div>

      <!-- ── Add New User fields ── -->
      <ng-container *ngIf="selectedRequestType === 'Add New User'">
        <div class="form-section">

          <!-- Email / Enterprise ID -->
          <div class="form-row">
            <label class="field-label">Email / Enterprise ID <span class="required">*</span></label>
            <div (focusout)="validateAddUserEid()">
              <app-people-picker
                [(ngModel)]="addUserEmail"
                placeholder="Search by email or Enterprise ID..."
                (personSelected)="onPersonSelected($event)"
                (ngModelChange)="onAddUserEmailInput()">
              </app-people-picker>
            </div>
            <span class="field-error" *ngIf="showAddUserErrors && !addUserEmail.trim()">This field is required</span>
            <span class="field-error" *ngIf="addUserEmailError">{{ addUserEmailError }}</span>
          </div>

          <!-- First Name -->
          <div class="form-row">
            <label class="field-label">First Name <span class="required">*</span></label>
            <input class="form-input" type="text"
                   [class.error]="showAddUserErrors && !addUserFirstName.trim()"
                   [readonly]="addUserEidAutoFilled"
                   [class.form-input--readonly]="addUserEidAutoFilled"
                   [(ngModel)]="addUserFirstName" />
            <span class="field-error" *ngIf="showAddUserErrors && !addUserFirstName.trim()">This field is required</span>
          </div>

          <!-- Last Name -->
          <div class="form-row">
            <label class="field-label">Last Name <span class="required">*</span></label>
            <input class="form-input" type="text"
                   [class.error]="showAddUserErrors && !addUserLastName.trim()"
                   [readonly]="addUserEidAutoFilled"
                   [class.form-input--readonly]="addUserEidAutoFilled"
                   [(ngModel)]="addUserLastName" />
            <span class="field-error" *ngIf="showAddUserErrors && !addUserLastName.trim()">This field is required</span>
          </div>

          <!-- R&C Function / Designation -->
          <div class="form-row">
            <label class="field-label">R&amp;C Function / Designation <span class="required">*</span></label>
            <div class="add-user-designation-trigger"
                 [class.error]="showAddUserErrors && !addUserDesignation"
                 (click)="toggleDesignationDropdown()">
              <span [class.select-placeholder]="!addUserDesignation">{{ addUserDesignation || 'Select Designation' }}</span>
              <mat-icon class="select-arrow">keyboard_arrow_down</mat-icon>
              <div class="type-dropdown-list" *ngIf="showDesignationDropdown" (click)="$event.stopPropagation()">
                <div class="type-option" *ngFor="let opt of designationOptions" (click)="selectDesignation(opt)">{{ opt }}</div>
              </div>
            </div>
            <span class="field-error" *ngIf="showAddUserErrors && !addUserDesignation">This field is required</span>
          </div>

          <!-- Country -->
          <div class="form-row">
            <label class="field-label">Country <span class="required">*</span></label>
            <div class="add-user-country-trigger"
                 [class.error]="showAddUserErrors && !addUserCountry">
              <div class="country-select-display" (click)="toggleCountryDropdown()">
                <span [class.select-placeholder]="!addUserCountry">{{ addUserCountry || 'Select Country' }}</span>
                <mat-icon class="select-arrow">keyboard_arrow_down</mat-icon>
              </div>
              <div class="searchable-dropdown" *ngIf="showCountryDropdown" (click)="$event.stopPropagation()">
                <input type="text" class="searchable-dropdown__search"
                       [(ngModel)]="countrySearchTerm" placeholder="Search..." />
                <ul class="searchable-dropdown__list">
                  <li *ngFor="let c of filteredCountries" (mousedown)="selectCountry(c)">{{ c.name }}</li>
                  <li class="no-results" *ngIf="filteredCountries.length === 0">No matches</li>
                </ul>
              </div>
            </div>
            <span class="field-error" *ngIf="showAddUserErrors && !addUserCountry">This field is required</span>
          </div>

          <!-- Work Location (cascading on Country) -->
          <div class="form-row">
            <label class="field-label">Work Location <span class="required">*</span></label>
            <div class="add-user-location-trigger"
                 [class.disabled]="!addUserCountry"
                 [class.error]="showAddUserErrors && !addUserWorkLocation"
                 (click)="toggleWorkLocationDropdown()">
              <span [class.select-placeholder]="!addUserWorkLocation">{{ addUserWorkLocation || 'Select Work Location' }}</span>
              <mat-icon class="select-arrow">keyboard_arrow_down</mat-icon>
              <div class="type-dropdown-list add-user-scrollable-list" *ngIf="showWorkLocationDropdown" (click)="$event.stopPropagation()">
                <div *ngIf="workLocationList.length === 0" class="type-option add-user-empty-option">No locations available</div>
                <div class="type-option" *ngFor="let loc of workLocationList" (click)="selectWorkLocation(loc)">{{ loc }}</div>
              </div>
            </div>
            <span class="field-error" *ngIf="showAddUserErrors && !addUserWorkLocation">This field is required</span>
          </div>

          <!-- Expiration On (optional) -->
          <div class="form-row">
            <label class="field-label">Expiration On</label>
            <div class="form-input add-user-date-input cnr-date-picker-wrap"
                 (click)="openDatePicker(cnrPicker_expiry)">
              <span class="rc-date-display">{{ formatDateDisplay(addUserExpirationOn) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #cnrPicker_expiry type="date" class="rc-date-input-hidden"
                     [(ngModel)]="addUserExpirationOn"
                     [min]="todayDateStr" />
            </div>
          </div>

        </div>

        <span class="submit-error" *ngIf="submitError">{{ submitError }}</span>

        <!-- Action buttons -->
        <div class="form-actions">
          <button type="button" class="btn-cancel" (click)="cancelForm()">Cancel</button>
          <button type="button" class="btn-save" [disabled]="!isAddUserFormDirty || isSubmitting || !!addUserEmailError" (click)="saveAddUserForm()">
            <mat-icon>save</mat-icon>
            Send Request
          </button>
        </div>
      </ng-container>

      <!-- Accenture Operation Service Line fields -->
      <ng-container *ngIf="selectedRequestType === 'Accenture Operation Service Line'">

        <div class="form-section">

          <!-- Name of Accenture Operation Service Line -->
          <div class="form-row">
            <label class="field-label">
              Name of Accenture Operation Service Line <span class="required">*</span>
            </label>
            <input class="form-input" type="text"
                   [class.error]="(showErrors && !aoslName.trim()) || isDuplicateName"
                   [(ngModel)]="aoslName"
                   (ngModelChange)="checkDuplicate()" />
            <span class="field-error" *ngIf="isDuplicateName">
              The SL is already present in database
            </span>
            <span class="field-error" *ngIf="showErrors && !aoslName.trim() && !isDuplicateName">
              This field is required
            </span>
          </div>

          <!-- Contract Number | Master Customer Number -->
          <div class="form-row-2col">
            <div class="form-row">
              <label class="field-label">Contract Number</label>
              <input class="form-input" type="text" inputmode="numeric"
                     [(ngModel)]="aoslContractNumber" (keypress)="onlyNumbers($event)" />
            </div>
            <div class="form-row">
              <label class="field-label">Master Customer Number</label>
              <input class="form-input" type="text" inputmode="numeric"
                     [(ngModel)]="aoslMasterCustomerNumber" (keypress)="onlyNumbers($event)" />
            </div>
          </div>

          <!-- Market | Market Unit (cascading) -->
          <div class="form-row-2col">
            <div class="form-row">
              <label class="field-label">Market</label>
              <div class="market-select-trigger" (click)="toggleMarketDropdown()">
                <span [class.select-placeholder]="!aoslMarket">
                  {{ aoslMarket || 'Select Market' }}
                </span>
                <mat-icon class="select-arrow">keyboard_arrow_down</mat-icon>
                <div class="type-dropdown-list" *ngIf="showMarketDropdown" (click)="$event.stopPropagation()">
                  <div class="type-option" *ngFor="let opt of marketOptions" (click)="$event.stopPropagation(); selectMarket(opt)">
                    {{ opt }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <label class="field-label">Market Unit</label>
              <div class="market-unit-select-trigger"
                   [class.disabled]="!aoslMarket"
                   (click)="toggleMarketUnitDropdown()">
                <span [class.select-placeholder]="!aoslMarketUnit">
                  {{ aoslMarketUnit || 'Select Market Unit' }}
                </span>
                <mat-icon class="select-arrow">keyboard_arrow_down</mat-icon>
                <div class="type-dropdown-list" *ngIf="showMarketUnitDropdown" (click)="$event.stopPropagation()">
                  <div class="type-option" *ngFor="let opt of marketUnitOptions" (click)="$event.stopPropagation(); selectMarketUnit(opt)">
                    {{ opt }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Comments -->
          <div class="form-row">
            <label class="field-label">
              Comments/Summary/Notes/Issue <span class="required">*</span>
            </label>
            <textarea class="form-textarea" rows="5"
                      [class.error]="showErrors && !aoslComments.trim()"
                      [(ngModel)]="aoslComments"></textarea>
            <span class="field-error" *ngIf="showErrors && !aoslComments.trim()">
              This field is required
            </span>
          </div>

          <!-- Attachment -->
          <div class="form-row">
            <label class="field-label">Attachment</label>
            <input #fileInput type="file" multiple style="display:none" (change)="onFileSelected($event)" />
            <ng-container *ngIf="aoslAttachedFileNames.length > 0; else emptyUpload">
              <div class="upload-doc-area">
                <div class="upload-doc-trigger upload-doc-trigger--active" (click)="fileInput.click()">
                  <span class="material-symbols-outlined upload-doc-icon">attach_file</span>
                  <span class="upload-doc-label">Attach Document</span>
                </div>
                <div class="upload-doc-item" *ngFor="let name of aoslAttachedFileNames; let i = index">
                  <span class="doc-filename doc-filename--pending">{{ name }}</span>
                  <span class="material-symbols-outlined doc-delete-icon doc-delete-icon--active" (click)="removeAttachedFile(i)">delete</span>
                </div>
              </div>
            </ng-container>
            <ng-template #emptyUpload>
              <div class="field-upload upload-doc-trigger--active" (click)="fileInput.click()">
                <span class="material-symbols-outlined upload-icon">attach_file</span>
                <span class="upload-text">Upload Document</span>
              </div>
            </ng-template>
            <span class="attach-error" *ngIf="attachError">
              {{ attachError }}
              <span class="attach-error-close" (click)="attachError = ''">&#x2715;</span>
            </span>
          </div>

        </div>

        <span class="submit-error" *ngIf="submitError">{{ submitError }}</span>

        <!-- Action buttons -->
        <div class="form-actions">
          <button type="button" class="btn-cancel" (click)="cancelForm()">Cancel</button>
          <button type="button" class="btn-save" [disabled]="!isAoslFormDirty || isSubmitting" (click)="saveForm()">
            <mat-icon>save</mat-icon>
            Send Request
          </button>
        </div>

      </ng-container>

      <!-- ── Request Not Applicable Plan Review Activity/Stage fields ── -->
      <ng-container *ngIf="selectedRequestType === 'Request Not Applicable Plan Review Activity/Stage'">

        <div class="form-section">

          <!-- Review ID -->
          <div class="form-row">
            <label class="field-label">Review ID <span class="required">*</span></label>
            <div class="na-review-select-trigger"
                 [class.error]="(showNaErrors && !naSelectedReviewId) || naIsDuplicate"
                 (click)="toggleNaReviewDropdown()">
              <span [class.select-placeholder]="!naSelectedReviewLabel">
                {{ naSelectedReviewLabel || 'Select Review ID' }}
              </span>
              <mat-icon class="select-arrow">{{ naIsDuplicateChecking ? 'hourglass_empty' : 'keyboard_arrow_down' }}</mat-icon>
              <div class="type-dropdown-list na-review-scrollable-list" *ngIf="showNaReviewDropdown" (click)="$event.stopPropagation()">
                <div *ngIf="naReviewList.length === 0" class="type-option na-empty-option">No reviews available</div>
                <div class="type-option" *ngFor="let r of naReviewList" (click)="selectNaReview(r)">{{ r.label }}</div>
              </div>
            </div>
            <span class="field-error" *ngIf="showNaErrors && !naSelectedReviewId">This field is required</span>
            <span class="field-error" *ngIf="naIsDuplicate">The request for selected ReviewId already raised, please check request listing once.</span>
          </div>

          <!-- Reason for Not Applicable -->
          <div class="form-row">
            <label class="field-label">Reason for Not Applicable <span class="required">*</span></label>
            <textarea class="form-textarea" rows="5"
                      [class.error]="showNaErrors && !naReason.trim()"
                      [(ngModel)]="naReason"></textarea>
            <span class="field-error" *ngIf="showNaErrors && !naReason.trim()">This field is required</span>
          </div>

          <!-- Attachment -->
          <div class="form-row">
            <label class="field-label">Attachment</label>
            <input #naFileInput type="file" multiple style="display:none" (change)="onNaFileSelected($event)" />
            <ng-container *ngIf="naAttachedFileNames.length > 0; else naEmptyUpload">
              <div class="upload-doc-area">
                <div class="upload-doc-trigger upload-doc-trigger--active" (click)="naFileInput.click()">
                  <span class="material-symbols-outlined upload-doc-icon">attach_file</span>
                  <span class="upload-doc-label">Attach Document</span>
                </div>
                <div class="upload-doc-item" *ngFor="let name of naAttachedFileNames; let i = index">
                  <span class="doc-filename doc-filename--pending">{{ name }}</span>
                  <span class="material-symbols-outlined doc-delete-icon doc-delete-icon--active" (click)="removeNaAttachedFile(i)">delete</span>
                </div>
              </div>
            </ng-container>
            <ng-template #naEmptyUpload>
              <div class="field-upload upload-doc-trigger--active" (click)="naFileInput.click()">
                <span class="material-symbols-outlined upload-icon">attach_file</span>
                <span class="upload-text">Attach Document</span>
              </div>
            </ng-template>
            <span class="attach-error" *ngIf="naAttachError">
              {{ naAttachError }}
              <span class="attach-error-close" (click)="naAttachError = ''">&#x2715;</span>
            </span>
          </div>

        </div>

        <span class="submit-error" *ngIf="submitError">{{ submitError }}</span>

        <!-- Action buttons -->
        <div class="form-actions">
          <button type="button" class="btn-cancel" (click)="cancelForm()">Cancel</button>
          <button type="button" class="btn-save" [disabled]="!isNaFormDirty || isSubmitting || naIsDuplicate || naIsDuplicateChecking" (click)="saveNaForm()">
            <mat-icon>save</mat-icon>
            Send Request
          </button>
        </div>

      </ng-container>

      <!-- ── Revised Target Publication Date fields ── -->
      <ng-container *ngIf="selectedRequestType === 'Revised Target Publication Date'">

        <div class="form-section">

          <!-- Review Name -->
          <div class="form-row">
            <label class="field-label">Review Name <span class="required">*</span></label>
            <div class="rtpd-review-select-trigger"
                 [class.error]="(showRtpdErrors && !rtpdSelectedReviewId) || rtpdIsDuplicate"
                 (click)="toggleRtpdReviewDropdown()">
              <span [class.select-placeholder]="!rtpdSelectedReviewLabel">
                {{ rtpdSelectedReviewLabel || 'Select Review' }}
              </span>
              <mat-icon class="select-arrow">{{ rtpdIsDuplicateChecking ? 'hourglass_empty' : 'keyboard_arrow_down' }}</mat-icon>
              <div class="type-dropdown-list na-review-scrollable-list" *ngIf="showRtpdReviewDropdown" (click)="$event.stopPropagation()">
                <div *ngIf="isLoadingRtpdReviews" class="type-option na-empty-option">Loading...</div>
                <div *ngIf="!isLoadingRtpdReviews && rtpdReviewList.length === 0" class="type-option na-empty-option">No reviews available</div>
                <div class="type-option" *ngFor="let r of rtpdReviewList" (click)="selectRtpdReview(r)">{{ r.label }}</div>
              </div>
            </div>
            <span class="field-error" *ngIf="showRtpdErrors && !rtpdSelectedReviewId">This field is required</span>
            <span class="field-error" *ngIf="rtpdIsDuplicate">The request for selected ReviewId already raised, please check request listing once.</span>
          </div>

          <!-- New Target Date -->
          <div class="form-row">
            <label class="field-label">New Target Date <span class="required">*</span></label>
            <input class="form-input add-user-date-input" type="date"
                   [class.error]="showRtpdErrors && !rtpdNewTargetDate"
                   [(ngModel)]="rtpdNewTargetDate"
                   [min]="todayDateStr" />
            <span class="field-error" *ngIf="showRtpdErrors && !rtpdNewTargetDate">This field is required</span>
          </div>

          <!-- Reason -->
          <div class="form-row">
            <label class="field-label">Reason <span class="required">*</span></label>
            <textarea class="form-textarea" rows="5"
                      placeholder="Enter reason for this request..."
                      [class.error]="showRtpdErrors && !rtpdReason.trim()"
                      [(ngModel)]="rtpdReason"></textarea>
            <span class="field-error" *ngIf="showRtpdErrors && !rtpdReason.trim()">This field is required</span>
          </div>

        </div>

        <span class="submit-error" *ngIf="submitError">{{ submitError }}</span>

        <!-- Action buttons -->
        <div class="form-actions">
          <button type="button" class="btn-cancel" (click)="cancelForm()">Cancel</button>
          <button type="button" class="btn-save" [disabled]="!isRtpdFormDirty || isSubmitting || rtpdIsDuplicate || rtpdIsDuplicateChecking" (click)="saveRtpdForm()">
            <mat-icon>save</mat-icon>
            Send Request
          </button>
        </div>

      </ng-container>

    </div>
  </div>
</main>
